import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PatientService } from '../patient.service';

export const useGetPatients = (
	params?: Patients.PatientParams,
	options?: Omit<
		UseQueryOptions<Patients.GetPatientsResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['patients', params],
		queryFn: () => PatientService.get(params),
		refetchOnWindowFocus: false,
		...options,
	});
};

/** Lista pacientes de um profissional (Admin/Support). */
export const useGetPatientsByProfessional = (
	professionalId: string | undefined,
	params?: Omit<Patients.PatientParams, 'professional_id'>,
	options?: Omit<
		UseQueryOptions<Patients.GetPatientsResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	const queryParams: Patients.PatientParams | undefined = professionalId
		? { ...(params ?? {}), professional_id: professionalId }
		: undefined;

	return useGetPatients(queryParams, {
		...options,
		enabled: !!professionalId && (options?.enabled ?? true),
	});
};

export const useGetPatient = (
	id: string,
	options?: Omit<
		UseQueryOptions<Patients.Patient, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['patient', id],
		queryFn: () => PatientService.getById(id),
		enabled: !!id,
		refetchOnWindowFocus: false,
		...options,
	});
};
